var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"celebrate-container"},[_c('confetti',_vm._b({ref:"confetti",on:{"celebration-complete":_vm.onCelebrationComplete,"celebration-stopped":_vm.onCelebrationStopped}},'confetti',_vm.confettiConfig,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }